import React from 'react';
import Popover from '@gik/ui/Popover/Popover';
import { InkindPageViewHistoryItem } from '@gik/inkind-page';
import InkindPickerContent from './InkindPickerContent';

export interface IInkindPickerProps {
  productNonD2CUrl: string;
  disableInterstitial?: boolean;
  inkindPageViewHistory: InkindPageViewHistoryItem[];
  isOpen: boolean;
  buyForSomeoneElseEnabled?: boolean;
  popoverTrigger: JSX.Element;
  onClose(): void;
  onInkindPageChosen(inkindRouteId: string): void;
  onBuyForSomeoneElse(): void;
}

export default function InkindPicker({
  popoverTrigger,
  isOpen,
  inkindPageViewHistory,
  buyForSomeoneElseEnabled,
  onClose,
  onInkindPageChosen,
  onBuyForSomeoneElse,
}: IInkindPickerProps): React.ReactElement {
  return (
    <Popover trigger={popoverTrigger} isOpen={isOpen} onClose={onClose} noPad className="gik-inkind-picker-popover">
      {isOpen && (
        <InkindPickerContent
          onInkindPageChosen={onInkindPageChosen}
          onBuyForSomeoneElse={onBuyForSomeoneElse}
          inkindPageViewHistory={inkindPageViewHistory}
          buyForSomeoneElseEnabled={buyForSomeoneElseEnabled}
        />
      )}
    </Popover>
  );
}
